module.exports = __webpack_public_path__ + "static/media/360.fe300cc5.jpg";